const stringifyQuery = (query: Query) => {
    return (Object.keys(query) as Array<keyof Query>)
        .map((key) => {
            const value = query[key]
            if (typeof value !== 'undefined') {
                const encodedKey = encodeURIComponent(key)
                if (Array.isArray(value)) {
                    const withoutEmptyValues = value.filter(Boolean)
                    if (!withoutEmptyValues.length) return
                    return `${encodedKey}=${withoutEmptyValues.join(`&${encodedKey}=`)}`
                }
                return `${encodedKey}=${encodeURIComponent(value)}`
            }
        })
        .filter(Boolean)
        .join('&')
}

const patchURLWithQuery = (path: string, query?: Query) =>
    query ? `${path}${path.includes('?') ? '&' : '?'}${stringifyQuery(query)}` : path

const http = <T>({ method = 'GET', url, query, body, headers, credentials }: Props): Promise<T> =>
    fetch(patchURLWithQuery(url, query), { method, headers, body, credentials }) as Promise<T>

export default http

export type Method = 'GET' | 'POST' | 'PUT' | 'DELETE'

export type Query = Record<string, string | number | boolean | undefined>

export type Body =
    | string
    | Blob
    | ArrayBufferView
    | ArrayBuffer
    | FormData
    | URLSearchParams
    | ReadableStream<Uint8Array>
    | null

export type Props = {
    url: string
    query?: Query
    method?: Method
    headers?: HeadersInit
    body?: Body
    credentials?: RequestCredentials
}
